<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="440px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    class="live-overview-dialog"
    center
  >
    <div slot="title" class="dialog-title">
      <p class="title">{{ liveInfo.lesson_name }}</p>
    </div>
    <div
      class="dialog-content"
      :class="{ is_open_sell: liveInfo.is_open_sell }"
    >
      <div class="content-item">
        <p class="data">
          {{
            handleDuration(
              liveInfo.room_end_time - liveInfo.room_start_time || 0
            ) || "-"
          }}
        </p>
        <p class="title">直播时长</p>
      </div>
      <div class="divider"></div>
      <div class="content-item num">
        <p class="data">{{ liveInfo.live_num || 0 }}人</p>
        <p class="title">参与人数</p>
      </div>
      <div class="divider" v-if="liveInfo.is_open_sell"></div>
      <div class="content-item amount" v-if="liveInfo.is_open_sell">
        <p
          class="data"
          v-html="formatPrice(liveInfo.live_sell_amount || 0)"
        ></p>
        <p class="title">售课金额</p>
      </div>
    </div>
    <div class="btns">
      <el-button class="view-btn" @click="viewReport">查看报告</el-button>
      <el-button class="confrim-btn" @click="handleClose">确 认</el-button>
    </div>
    <div class="tips-box">
      <div class="text">直播录制成功</div>
      <div class="btn" @click="viewReply">查看课程回放</div>
    </div>
  </el-dialog>
</template>

<script>
import { isMobile } from "@saas/components/src";
import { getLiveSta } from "@saas/service-api/src/live-list";
import formatTime from "@saas/components/src/utils/filters.js";

export default {
  data: function () {
    return {
      lessonId: "",
      courseId: "",
      dialogVisible: false,
      liveInfo: {
        live_num: 0,
        is_open_sell: true,
        room_end_time: 0,
        room_start_time: 0,
        lesson_name: "",
        live_sell_amount: 0,
      },
      parseTime: formatTime.formatSelfTime,
    };
  },
  methods: {
    openDialog(obj) {
      console.log("obj___", obj);

      this.lessonId = obj.lessonId;
      this.courseId = obj.courseId;
      this.getLiveSta();
    },
    getLiveSta() {
      getLiveSta({
        lesson_id: this.lessonId,
      }).then((res) => {
        if (res.code === 1) {
          this.dialogVisible = true;
          this.liveInfo = res.data;
        } else if ([4444, 6666].includes(res.code)) {
          this.$message.error("课程已被删除");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.lessonId = "";
      this.liveInfo = {};
    },
    viewReport() {
      const isNewLive = this.liveInfo.is_new_live === 1;
      const url = isNewLive
        ? `/new-live-data/${this.lessonId}`
        : `/live-data/${this.lessonId}`;
      if (window.isElectron || isMobile()) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    viewReply() {
      if (window.isElectron) {
        this.$router.push({
          path: "/learning-center/course-detail/" + this.courseId,
          query: {
            lesson_id: this.lessonId,
          },
        });
      } else {
        this.$router.push({
          path: "/course-detail/" + this.courseId,
          query: {
            lesson_id: this.lessonId,
          },
        });
      }
    },
    formatPrice(val) {
      if (val) {
        const price = (val / 100).toFixed(2);
        const arr = price.split(".");
        return `<div><span class="symbol">¥</span><span>${arr[0]}</span><span class="decimal">.${arr[1]}</span></div>`;
      } else {
        return "-";
      }
    },
    // 处理市场吧时长转成1:09:34格式，如果没有小时不展示
    handleDuration(milliseconds) {
      if (!milliseconds) {
        return "";
      }
      const totalSeconds = Math.floor(milliseconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (!hours) {
        return `${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`;
      } else {
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      }
    },
  },
  computed: {
    modeList() {
      if (this.liveInfo.course_type === 1) {
        return this.normalClassModes;
      } else {
        return this.smallClassModes;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.live-overview-dialog {
  ::v-deep .el-dialog {
    background: #ffffff;
    border-radius: 18px;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
    padding-top: 24px;
    padding-bottom: 10px;
  }
  ::v-deep .el-dialog__close {
    color: #4e5969;
    font-size: 14px;
    font-weight: bold;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 5px;
    right: 10px;
  }
  ::v-deep .el-dialog__body {
    padding: 0 10px 20px 10px;
  }
  .dialog-title {
    .title {
      font-size: 14px;
      color: #0d1400;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      color: $saas-text-color;
      line-height: 22px;
      .icon {
        margin-left: 8px;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
    }
    .tips {
      margin-top: 7px;
      font-weight: 400;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
      text-align: center;
    }
  }
  .dialog-content {
    display: flex;
    flex-direction: row;
    height: 64px;
    .content-item {
      flex: 1;
      &.amount {
        .data ::v-deep {
          color: #f03349;
          .symbol {
            font-size: 18px;
          }
          .decimal {
            font-size: 20px;
          }
        }
      }
      &:first-child {
        margin-left: 50px;
      }
      &:last-child {
        margin-left: 26px;
      }
      .data {
        font-weight: bold;
        font-size: 26px;
        color: #0d1400;
        line-height: 35px;
      }
      .title {
        margin-top: 6px;
        font-weight: 400;
        font-size: 14px;
        color: #515350;
        line-height: 20px;
      }
    }
    .divider {
      width: 1px;
      height: 64px;
      background: linear-gradient(
        180deg,
        rgba(244, 244, 247, 0) 0%,
        #f2f2f5 14%,
        #e7e8ec 89%,
        rgba(229, 230, 235, 0) 100%
      );
    }
  }
  .is_open_sell {
    .content-item {
      &.amount {
        .data {
          color: #f03349;
        }
      }
      &:first-child {
        flex: 1;
        margin-left: 20px;
      }
      &:last-child {
        flex: 1;
        margin-left: 26px;
      }
    }
    .num {
      flex: unset;
      width: 96px;
      padding: 0 20px;
    }
  }
  .btns {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 40px;
  }
  .confrim-btn {
    width: 78px;
    height: 36px;
    background: #f2f3f5;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: $saas-text-color;
    line-height: 36px;
    margin-right: 16px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .view-btn {
    width: 100px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(
      132deg,
      $linear-gradient-begin 0%,
      $linear-gradient-end 100%
    );
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .view-btn:disabled {
    opacity: 0.5;
  }
  .free-icon {
    width: 42px;
    height: 20px;
    margin-left: 8px;
  }
  .tips-box {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .text {
      font-weight: 400;
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
    .btn {
      cursor: pointer;
      font-weight: 400;
      font-size: 12px;
      color: #00c89d;
      line-height: 17px;
      margin-left: 10px;
    }
  }
}
</style>
